import { t } from 'ttag';

import SafePaymentIcon from '@svg/safe-payment.svg';
import UaFlagIcon from '@svg/ua-flag.svg';
import DeliveryIcon from '@svg/free-delivery.svg';
import SwapLogoIcon from '@svg/swap-logo.svg';

import s from './ProductDetailsLabels.sss';

interface Props {
  isSafePayment?: boolean,
  isMadeInUkraine?: boolean,
  isFreeDelivery?: boolean,
  isSmart?: boolean,
  isSwap?: boolean,
}

export const ProductDetailsLabels: React.FC<Props> = ({
  isSafePayment,
  isMadeInUkraine,
  isFreeDelivery,
  isSmart,
  isSwap,
}) => (
  <ul className={s.list}>
    {isSafePayment && (
      <li className={s.item}>
        <SafePaymentIcon
          className={s.icon}
          width="16"
          height="16"
        />
        <span className={s.caption}>
          {t`Безпечна оплата`}
        </span>
      </li>
    )}
    {isMadeInUkraine && (
      <li className={s.item}>
        <UaFlagIcon
          className={s.icon}
          width="16"
          height="16"
        />
        <span className={s.caption}>
          {t`Зроблено в Україні`}
        </span>
      </li>
    )}
    {isFreeDelivery && (
      <li className={s.item}>
        <DeliveryIcon
          className={s.icon}
          width="16"
          height="16"
        />
        <span className={s.caption}>
          {t`Безкоштовна доставка`}
        </span>
      </li>
    )}
    {isSmart && (
      <li className={s.item}>
        <DeliveryIcon
          className={s.icon}
          width="16"
          height="16"
        />
        <span className={s.caption}>
          {t`Безкоштовна доставка SMART`}
        </span>
      </li>
    )}
    {isSwap && (
      <li className={s.item}>
        <SwapLogoIcon
          className={s.icon}
          width="16"
          height="16"
        />
        <span className={s.caption}>
          {t`SWAP-паті`}
        </span>
      </li>
    )}
  </ul>
);
